import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Flex, IconArrow1Down, IconArrow1Up } from 'mailup-web-components'
import styled from '@emotion/styled'
import { keyframes } from '@emotion/core'

const SelectHeader = ({ title, isActive, onChangeActive }) => {
  const [animation, setAnimation] = useState(false)

  const handleClick = () => {
    setAnimation(true)
    onChangeActive()
  }

  return (
    <>
      <StyledFlex
        justifyContent='space-between'
        margin='0 0 8px 0'
        onClick={handleClick}
        isActive={isActive}
      >
        {title.toUpperCase()}
        {isActive ? (
          <StyledIconDown animation={animation} />
        ) : (
          <StyledIconUp animation={animation} />
        )}
      </StyledFlex>
    </>
  )
}

export default SelectHeader

SelectHeader.propTypes = {
  title: PropTypes.string,
  isActive: PropTypes.bool,
  onChangeActive: PropTypes.func
}

const StyledFlex = styled(Flex)`
  cursor: ${({ isActive }) => (isActive ? 'unset' : 'pointer')};
  color: ${({ isActive }) => (isActive ? 'var(--java)' : 'var(--boulder)')};
`

const rotateTo180 = keyframes`
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(180deg); }
  `

const StyledIconUp = styled(IconArrow1Up)`
  animation: ${rotateTo180} ${({ animation }) => (animation ? 250 : 0)}ms 0s
    linear forwards;
`
const StyledIconDown = styled(IconArrow1Down)`
  animation: ${rotateTo180} ${({ animation }) => (animation ? 250 : 0)}ms 0s
    linear forwards;
`
